/**
 * This file is included on every page and is used to display a cookie banner consent message to the user
 * upon first loading the application
 */

module.exports = ($, M, i18n) => {
  return () => {
    const urlParams = new URL(window.location.href).searchParams;
    if (urlParams.get('headless') === null) {
      // The path does not contain the locale if the language is english
      const languagePath = M.LANG && M.LANG !== 'en' ? `/${M.LANG}` : '';
      const cookiePolicyLink = `https://www.memrise.com${languagePath}/cookies`;

      const cookieBannerText = _t('web_cookie_banner_text').replace(
        '<a>',
        `<a href=${cookiePolicyLink}>`,
      );
      const cookieBannerButton = _t('web_cookie_banner_button');

      window.cookieconsent.initialise({
        palette: {
          popup: { background: '#FFFFFF' },
          button: { background: '#2B3648' },
        },
        layout: 'memrise-cookie-banner',
        layouts: {
          'memrise-cookie-banner': '{{message}}{{allow}}',
        },
        theme: 'corporate',
        domain: M.DOMAIN,
        name: 'memrise-cookie-consent',
        content: {
          message: cookieBannerText,
          allow: cookieBannerButton,
        },
        location: false,
        href: cookiePolicyLink,
      });
    }
  };
};
